// postMessage link to the preview iframe. Messages sent before the iframe
// says `ready` are queued, and the last `select` is replayed after a reload
// (story file edits reload the iframe through Vite).

export function createBridge() {
  let frame = null;
  let ready = false;
  let queue = [];
  const listeners = new Set();

  window.addEventListener('message', (event) => {
    const msg = event.data;
    if (!msg || msg.source !== 'edl-docs-preview') return;
    if (frame && event.source !== frame.contentWindow) return;
    log.push({ t: Date.now(), in: msg.type, id: msg.id, frame: Boolean(frame) });
    if (log.length > 50) log.shift();
    if (msg.type === 'ready') {
      // The iframe (re)loaded: Vite reloads it after optimising deps or when a
      // story file changes. Listeners re-send the selection from current
      // state; queued non-selection messages follow.
      ready = true;
      const pending = queue;
      queue = [];
      for (const fn of listeners) fn(msg);
      for (const m of pending) post(m);
      return;
    }
    for (const fn of listeners) fn(msg);
  });

  const log = [];
  function post(message) {
    log.push({ t: Date.now(), out: message.type, id: message.id });
    if (log.length > 50) log.shift();
    frame?.contentWindow?.postMessage({ ...message, source: 'edl-docs-shell' }, '*');
  }

  return {
    attach(iframe) {
      if (frame === iframe) return;
      frame = iframe;
      ready = false;
    },
    detach(iframe) {
      if (frame === iframe) {
        frame = null;
        ready = false;
      }
    },
    send(message) {
      if (ready) post(message);
      // Selections are re-sent on `ready` from current state; queue the rest.
      else if (!['select', 'updateArgs', 'resetArgs', 'remount'].includes(message.type)) queue.push(message);
    },
    log,
    isReady() {
      return ready;
    },
    onMessage(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    markReloading() {
      ready = false;
    },
  };
}
